export default __webpack_public_path__ + "static/media/pp.1bbab42b.png";